import { BUNDLED_DISEASE } from 'utils/constants/disease';

const CANCER_TYPE_RENDER_CONDITION = {
  [BUNDLED_DISEASE.LUNG]: {
    nct03964727: false,
  },
  [BUNDLED_DISEASE.UTERINE]: {
    nct03964727: false,
  },
};

export const shouldShowTrialByCancerType = (cancerType, nctNumber) => {
  const adjustedNctNumber = nctNumber.toLowerCase();
  const cancerNcts = CANCER_TYPE_RENDER_CONDITION[cancerType?.toLowerCase()];

  return cancerNcts ? (adjustedNctNumber in cancerNcts ? cancerNcts[adjustedNctNumber] : true) : true;
};
